export default "__VITE_ASSET__172da793__"